export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-lock-dc1422edac6d034964082088fc73ee31.svg";